<div class="notification-container">
  @for (notification of notifications(); track notification.id) {
    <div 
      class="notification notification-{{notification.type}}"
      [@slideIn]
      (click)="remove(notification.id)">
      
      <div class="notification-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path [attr.d]="getIcon(notification.type)" />
        </svg>
      </div>
      
      <div class="notification-content">
        <div class="notification-title">{{ notification.title }}</div>
        @if (notification.message) {
          <div class="notification-message">{{ notification.message }}</div>
        }
      </div>
      
      <button class="notification-close" (click)="remove(notification.id); $event.stopPropagation()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  }
</div>

